import { TFunction } from 'i18next';
import { useTranslation } from 'next-i18next';

import Tabs from '@/shared/components/atoms/Tabs';

export const TAB_QUERY_INDICATOR = 'inventoryTab';
const getTimelineTabsList = (t: TFunction) => [
  {
    label: t('Transactions'),
    value: 'transactions',
  },
  {
    label: t('Pending Requests'),
    value: 'pendingRequests',
  },
];

const InventoryTabs = () => {
  const { t } = useTranslation();
  return (
    <Tabs
      getLabel={(item) => item?.label}
      getValue={(item) => item?.value}
      tabsList={getTimelineTabsList(t)}
      variant='connected'
      defaultValue='transactions'
      tabQueryIndicator={TAB_QUERY_INDICATOR}
      linkClassName='px-12 py-6'
      activeClassName='!bg-blue-100 '
    />
  );
};

export { InventoryTabs };
